import axios from 'axios'

// baseURL configurável por ambiente via variável de build do Vue CLI:
// - prod/homolog (Node-RED): mantém o default abaixo (ou seta a URL completa).
// - ambiente Go (same-origin): build com VUE_APP_API_BASE_URL=/api, resolve o antigo
//   truque de editar este arquivo à mão (que nunca era commitado).
const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://50.116.45.148:1883'

const http = axios.create({
  baseURL,
  timeout: 1000000
})

// Sessão expirada/inválida: o backend responde 401 nas rotas protegidas
// (ex.: iniciar/entrar numa luta). Limpa a credencial e manda pro login, em vez
// de deixar a ação falhar silenciosamente (que dava telas vazias/"não foi possível").
//
// Só vale para quem TINHA sessão. Visitante anônimo pode esbarrar num endpoint
// protegido dentro de uma tela pública (ex.: a duração do evento no Resumo, que
// é exclusiva de Admin/Organizador): ali o 401 é esperado, a tela apenas deixa de
// exibir aquele dado, e mandar pro login quebraria a consulta pública de resumo,
// grupos, chaves e agenda.
http.interceptors.response.use(
  (response) => response,
  (error) => {
    let hadSession = false
    try {
      hadSession = !!localStorage.getItem('token')
    } catch (e) { /* localStorage indisponível: trata como anônimo */ }

    if (error && error.response && error.response.status === 401 && hadSession) {
      try {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
      } catch (e) { /* localStorage indisponível: ignora */ }
      const path = window.location.pathname || ''
      if (!/\/SignIn|\/SignUp/i.test(path)) {
        window.location.assign('/SignIn')
      }
    }
    return Promise.reject(error)
  }
)

export const services = host =>
  axios.create({
    baseURL: host,
    timeout: 1000000
  })

export default http
